import { Injectable } from '@angular/core';
import { Route, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ISessionService } from '@insight/services';

@Injectable({
	providedIn: 'root'
})
export class SalesSummaryGuardService {

	constructor(
		private router: Router,
		private sessionService: ISessionService
	) { }

	canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean> {
		if (!this.sessionService.isAuth()) {
			return of(this.router.createUrlTree(['/auth/login']));
		}

		if (!this.sessionService.hasMn('frontend.pem')) {
			// return of(this.router.createUrlTree(['/unauthorized-access']));
			return this.router.navigateByUrl('/unauthorized-access', {
				skipLocationChange: true
			});
		}

		return of(true);
	}
}
